import React from 'react';
import { MapPin, Clock3, Phone as PhoneIcon } from 'lucide-react';

/**
 * The one-line facts under the photo collage on the guest booking screen:
 * address (linked to Google Maps when there's a link), slot length, and the
 * club's phone number. Shared by both UI design versions; styled in
 * global.css (.booking-info-bar).
 *
 * @param {object} props
 * @param {string} [props.locationText] - Config -> Basic -> location
 * @param {string|null} [props.mapLinkUrl] - from getMapLinkUrl(config); null when there is none
 * @param {string} [props.contactNumber] - Config -> Basic -> contact number
 * @returns {JSX.Element}
 */
function BookingInfoBar({ locationText, mapLinkUrl, contactNumber }) {
  return (
    <div className="booking-info-bar">
      {/* getMapLinkUrl, not config.mapsUrl — an embed URL opened as a page
          errors with "must be used in an iframe". */}
      {/* info-pill-wide: the address is the one pill with no length limit, so
          it's the one allowed to wrap onto a second line (see global.css).
          The others stay on one line. */}
      {mapLinkUrl ? (
        <a className="info-pill info-pill-wide" href={mapLinkUrl} target="_blank" rel="noopener noreferrer">
          <MapPin size={15} /><span>{locationText || 'Our location'}</span>
        </a>
      ) : locationText && (
        <span className="info-pill info-pill-wide"><MapPin size={15} /><span>{locationText}</span></span>
      )}
      {/* Hours moved to the configurable Court Details cards (Config -> Court
          Details), so this pill states the one fact that's always true of the
          grid below it. */}
      <span className="info-pill"><Clock3 size={15} />60-min slots</span>
      {contactNumber && (
        <a className="info-pill" href={`tel:${contactNumber}`}>
          <PhoneIcon size={15} /><span>{contactNumber}</span>
        </a>
      )}
    </div>
  );
}

export default BookingInfoBar;
